import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { NotificationsService } from '@services/notifications.service';
import { UserService } from '@services/user.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { HttpUtilService } from '@services/http-util.service';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'scaffold-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss'],
    standalone: false
})
export class EmailComponent extends BaseScaffoldComponent implements OnInit {
  public subject: string;
  public body: string;
  public isSending: boolean = false;
  constructor(
    public http: HttpUtilService,
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public userService: UserService,
    public notification: NotificationsService,
    private translationService: TranslationService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit(): void {}
  sendEmail() {
    this.isSending = true;
    const userInfo = this.userService.getUserInfo();
    const body = {
      sentFrom: userInfo,
      subject: this.subject,
      body: this.body,
      sendTo: Array.isArray(this.item?.email_to)
        ? this.item?.email_to
        : [this.item?.email_to],
    };

    this.http
      .request('post', `${environment.apiRoot}/email`, body, null, true)
      .pipe(catchError(error => of({ errorMessage: error })))
      .subscribe(res => this.handleResponse(res));
  }

  handleResponse(response) {
    this.isSending = false;
    this.subject = '';
    this.body = '';
    const message = response?.errorMessage
      ? this.translationService.getTranslatedContent(
          'error_sending_message',
          'Error Sending Message'
        )
      : this.translationService.getTranslatedContent(
          'successfully_sent_message',
          'Successfully Sent Message'
        );

    this.notification.popNotification(message, '');

    this.cdr.detectChanges();
  }
}
